export const EDIT_FIELDS = ['restrictedToUsers_edit', 'restrictedToGroups_edit'];
